(function () {
  const players = document.querySelectorAll('.player');

  players.forEach((playerWrapper) => {
    const audio = playerWrapper.querySelector('audio');
    const playlist = playerWrapper.querySelectorAll('#playlist a');
    const isFloating = playerWrapper.closest('.template-product') !== null;
    const openButton = document.querySelector('.open-player');

    if (!audio || !playlist.length) return;

    let currentTrack = 0;
    audio.volume = 0.1;

    function playTrack(index) {
      const selected = playlist[index];
      if (!selected) return;

      playlist.forEach(el => el.parentElement.classList.remove('active'));
      selected.parentElement.classList.add('active');

      audio.src = selected.getAttribute('href');
      audio.play();
      currentTrack = index;
    }

    playlist.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        playTrack(index);
      });
    });

    audio.addEventListener('ended', () => {
      const nextIndex = (currentTrack + 1) % playlist.length;
      playTrack(nextIndex);
    });

    // === FONCTIONNALITÉS UNIQUEMENT POUR LE PLAYER FLOTTANT ===
    if (isFloating && openButton) {
      // Resize bouton toggle
      const resizeOpenPlayer = () => {
        openButton.style.width = playerWrapper.offsetHeight + 'px';
      };

      resizeOpenPlayer();
      window.addEventListener('resize', resizeOpenPlayer);

      // Toggle au clic
      openButton.classList.remove('start');
      openButton.addEventListener('click', () => {
        playerWrapper.classList.toggle('open');
      });

      // Ouverture automatique 1x
      const wasOpened = sessionStorage.getItem('OpenPlayer');
      if (wasOpened !== 'Player Opened') {
        setTimeout(() => {
          openButton.click();
          setTimeout(() => {
            openButton.click();
            sessionStorage.setItem('OpenPlayer', 'Player Opened');
          }, 1000);
        }, 1000);
      }

      // Clic extérieur → fermeture
      document.addEventListener('click', (event) => {
        const clickedInsidePlayer = playerWrapper.contains(event.target);
        const clickedToggle = openButton.contains(event.target);

        if (playerWrapper.classList.contains('open') && !clickedInsidePlayer && !clickedToggle) {
          playerWrapper.classList.remove('open');
        }
      });
    }
  });

// Solution complète pour gérer la personnalisation dans tous les contextes
document.addEventListener('DOMContentLoaded', () => {
  
  const toggleField = (variantId, container) => {
    if (!container) {
      console.warn('Container non trouvé pour toggleField');
      return;
    }

    const customizationRow = container.querySelector('.customization-row');
    const inputField = customizationRow?.querySelector('input#prenom');
    const variantScript = customizationRow?.querySelector('script[type="application/json"][id^="VariantsWithPersonalization-"]');
  
    if (!customizationRow || !inputField || !variantScript) {
      console.warn('Bloc ou JSON de personnalisation non trouvé dans', container);
      return;
    }
  
    let variantMetaMap = {};
    try {
      variantMetaMap = JSON.parse(variantScript.textContent);
    } catch (e) {
      console.error('JSON invalid dans VariantsWithPersonalization', e);
      return;
    }
  
    const isPersonalizable = variantMetaMap?.[variantId]?.personalizable;
    console.log('toggleField - variant:', variantId, 'personalizable:', isPersonalizable);
  
    if (isPersonalizable) {
      customizationRow.style.display = 'flex';
      inputField.setAttribute('required', 'required');
      
      // Synchroniser avec le champ caché
      const hiddenInput = container.querySelector('[data-prenom-hidden]');
      if (hiddenInput && inputField.value) {
        hiddenInput.value = inputField.value;
      }
    } else {
      customizationRow.style.display = 'none';
      inputField.removeAttribute('required');
      inputField.value = '';
      inputField.classList.remove('input--error');
      
      const errorMessage = customizationRow.querySelector('.form__error-message');
      if (errorMessage) {
        errorMessage.setAttribute('hidden', 'true');
      }
      
      // Vider aussi le champ caché
      const hiddenInput = container.querySelector('[data-prenom-hidden]');
      if (hiddenInput) {
        hiddenInput.value = '';
      }
    }
  };  

  // Fonction pour initialiser les champs dans un container donné
  const initializePersonalization = (container) => {
    const variantInput = container.querySelector('input[name="id"]');
    const variantId = variantInput?.value;
    
    if (variantId) {
      console.log('Initializing personalization for variant:', variantId);
      toggleField(variantId, container);
    }
  };

  // Initialiser sur la fiche produit au chargement
  const productComponents = document.querySelectorAll('product-component');
  productComponents.forEach(initializePersonalization);

  // Observer pour détecter les nouveaux éléments ajoutés au DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Vérifier si c'est un dialog Quick Add
          if (node.matches?.('[data-quick-add-modal]') || node.querySelector?.('[data-quick-add-modal]')) {
            console.log('Quick Add modal détecté');
            
            // Attendre que le contenu soit chargé
            setTimeout(() => {
              const modal = node.matches('[data-quick-add-modal]') ? node : node.querySelector('[data-quick-add-modal]');
              if (modal) {
                const container = modal.querySelector('[data-api-content]') || modal.querySelector('[data-product-upsell-ajax]');
                if (container) {
                  console.log('Initializing Quick Add modal');
                  initializePersonalization(container);
                  
                  // Écouter les changements de variante dans cette modale
                  const productForm = container.querySelector('product-form');
                  if (productForm) {
                    productForm.addEventListener('theme:variant:change', (evt) => {
                      console.log('Variant change dans Quick Add modal', evt);
                      const variantId = evt.detail?.variant?.id;
                      if (variantId) {
                        toggleField(variantId, container);
                      }
                    });
                  }
                }
              }
            }, 300); // Délai pour laisser le temps au contenu AJAX de se charger
          }
          
          // Vérifier si du contenu API a été ajouté
          if (node.matches?.('[data-api-content]') || node.querySelector?.('[data-api-content]')) {
            const apiContent = node.matches('[data-api-content]') ? node : node.querySelector('[data-api-content]');
            console.log('API content ajouté');
            setTimeout(() => {
              initializePersonalization(apiContent);
            }, 100);
          }
        }
      });
    });
  });

  // Observer le body pour détecter l'ajout de nouveaux éléments
  observer.observe(document.body, { childList: true, subtree: true });

  // Listener global pour les changements de variante
  document.addEventListener('theme:variant:change', (evt) => {
    console.log("theme:variant:change global", evt);
    
    const variantId = evt.detail?.variant?.id;
    if (!variantId) {
      console.warn('Pas de variant ID dans l\'événement');
      return;
    }
    
    // Essayer plusieurs stratégies pour trouver le container
    let container = evt.detail?.container;
    
    if (!container) {
      // Pour Quick Add modals
      const quickAddModal = evt.target?.closest('[data-quick-add-modal]');
      if (quickAddModal) {
        container = quickAddModal.querySelector('[data-api-content]') || quickAddModal;
      }
    }
    
    if (!container) {
      // Pour le contenu API product upsell
      container = evt.target?.closest('[data-api-content]');
    }
    
    if (!container) {
      // Pour les composants produit normaux
      container = evt.target?.closest('product-component, dialog, [data-product-upsell-ajax], .product');
    }
    
    if (!container) {
      console.warn('Container introuvable pour l\'événement', evt);
      return;
    }
    
    console.log("Container trouvé:", container);
    toggleField(variantId, container);
  });
  
  // Écouter quand les Quick Add modals s'ouvrent
  document.addEventListener('theme:quick-add:open', () => {
    console.log('Quick Add modal ouvert');
    setTimeout(() => {
      const openModals = document.querySelectorAll('[data-quick-add-modal][open]');
      openModals.forEach(modal => {
        const container = modal.querySelector('[data-api-content]');
        if (container) {
          initializePersonalization(container);
        }
      });
    }, 500);
  });
  
  // Listener de secours pour capturer les événements sur les boutons de variante
  document.addEventListener('click', (evt) => {
    const variantButton = evt.target.closest('[data-single-option-selector], [data-variant-buttons] input');
    if (variantButton) {
      // Attendre un peu pour que l'événement theme:variant:change soit déclenché
      setTimeout(() => {
        let container = variantButton.closest('[data-api-content]');
        if (!container) {
          container = variantButton.closest('[data-quick-add-modal]')?.querySelector('[data-api-content]');
        }
        if (!container) {
          container = variantButton.closest('product-component, dialog');
        }
        
        if (container) {
          const variantInput = container.querySelector('input[name="id"]');
          const variantId = variantInput?.value;
          if (variantId) {
            console.log('Click sur variante détecté, variant:', variantId);
            toggleField(variantId, container);
          }
        }
      }, 100);
    }
  });
  
  // Pour les changements de variante via select dropdown (dans Quick Add)
  document.addEventListener('change', (evt) => {
    if (evt.target.matches('[data-popout-input]')) {
      const container = evt.target.closest('[data-api-content]');
      if (container) {
        setTimeout(() => {
          const variantInput = container.querySelector('input[name="id"]');
          const variantId = variantInput?.value;
          if (variantId) {
            console.log('Change sur select détecté, variant:', variantId);
            toggleField(variantId, container);
          }
        }, 100);
      }
    }
  });
  
  // Listeners supplémentaires pour les événements Quick Add personnalisés
  document.addEventListener('theme:quick-add:ready', (evt) => {
    console.log('Quick Add ready event', evt.detail);
    const { container, variantId } = evt.detail;
    
    if (container && variantId) {
      // Réinitialiser la personnalisation
      const toggleField = window.toggleField; // Assurez-vous que toggleField est accessible globalement
      if (toggleField) {
        toggleField(variantId, container);
      }
    }
  });

  document.addEventListener('theme:quick-add:content-loaded', (evt) => {
    console.log('Quick Add content loaded', evt.detail);
    const { container } = evt.detail;
    
    if (container) {
      // Initialiser la personnalisation
      const variantInput = container.querySelector('input[name="id"]');
      const variantId = variantInput?.value;
      
      if (variantId) {
        const toggleField = window.toggleField;
        if (toggleField) {
          toggleField(variantId, container);
        }
      }
    }
  });
});
})();